import { REQUEST_METHOD } from "../../WebServiceManager/RequestService";
import { RequestHeader } from "../../WebServiceManager/RequestHeader";
import { RequestBody } from "../../WebServiceManager/RequestBody";
import LOCAL_KEYS, { parseLocalStorageJSON } from "../../../helpers/Localstorage";

export default class TimeOffRequestBody {
  requestTimeOffRequest = (payload, method) => {
    const header = new RequestHeader();
    const request = new RequestBody(
      method,
      header.applicationJson(parseLocalStorageJSON(LOCAL_KEYS.ACCESS_TOKEN)),
      payload,
    );
    return request;
  };

  getTimeOffRequestsRequest = (method) => {
    const header = new RequestHeader();
    const request = new RequestBody(
      method,
      header.applicationJson(parseLocalStorageJSON(LOCAL_KEYS.ACCESS_TOKEN)),
    );
    return request;

  };

  getAllTimeOffWithoutPaginationRequest = (method) => {
    const header = new RequestHeader();
    const request = new RequestBody(
      method,
      header.applicationJson(parseLocalStorageJSON(LOCAL_KEYS.ACCESS_TOKEN)),
    );
    return request;
  };
  
  getTimeOffByIdRequest = (method) => {
    const header = new RequestHeader();
    const request = new RequestBody(
      method,
      header.applicationJson(parseLocalStorageJSON(LOCAL_KEYS.ACCESS_TOKEN)),
    );
    return request;
  };

  updateTimeOffRequest = (payload, method) => {
    const header = new RequestHeader();
    const request = new RequestBody(
      method,
      header.applicationJson(parseLocalStorageJSON(LOCAL_KEYS.ACCESS_TOKEN)),
      payload,
    );
    return request;
  };

  cancelTimeOffRequest = (method) => {
    const header = new RequestHeader();
    const request = new RequestBody(
      method,
      header.applicationJson(parseLocalStorageJSON(LOCAL_KEYS.ACCESS_TOKEN)),
    );
    return request;
  };
}


